import { useOverlay } from '../../hooks/useOverlay';
import { useThemeStore } from '../../store/themeStore';
import TopBar from '../common/TopBar';
import AlarmSettings from './sections/AlarmSettings';
import ProfilesSettings from './sections/ProfilesSettings';
import ThemeSettings from './sections/ThemeSettings';
import TimerSettings from './sections/TimerSettings';

const SettingsOverlay: React.FC = () => {
    const { selectedTheme } = useThemeStore();

    const { isOpen, close } = useOverlay('settings');

    if (!isOpen) return null;

    return (
        <div
            className="absolute inset-0 z-40 flex size-full flex-col shadow-lg"
            style={{
                backgroundColor: selectedTheme.color.main,
                outline: `2px solid ${selectedTheme.color.sub}33`,
            }}
        >
            <TopBar.Back onLeftClick={close} center="Settings" />

            <div className="p-5">
                <div className="max-h-[calc(100vh-96px)] space-y-10 overflow-y-auto no-scrollbar">
                    <ProfilesSettings />
                    <ThemeSettings />
                    <TimerSettings />
                    <AlarmSettings />

                    <div className="border-t pt-6" style={{ borderColor: `${selectedTheme.color.sub}44` }}>
                        <button
                            onClick={() => {
                                if ('caches' in window) {
                                    caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
                                }
                                if ('serviceWorker' in navigator) {
                                    navigator.serviceWorker.getRegistrations().then((regs) =>
                                        regs.forEach((r) => r.unregister())
                                    );
                                }
                                window.location.reload();
                            }}
                            className="w-full rounded-2xl px-6 py-4 text-lg font-bold text-white transition-all hover:scale-[1.02] active:scale-95"
                            style={{ backgroundColor: selectedTheme.color.point }}
                        >
                            🔄 Force Reload New Version
                        </button>
                        <p className="mt-2 text-center text-xs opacity-50" style={{ color: selectedTheme.color.sub }}>
                            Clears cache &amp; reloads the app with the latest version
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsOverlay;
